import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        background: '#174458',
        primary: '#72b1df',
        secondary: '#424242',
        accent: '#FD8A8D',
        error: '#d50000',
        info: '#FEB5B7',
        success: '#4CAF50',
        warning: '#FB8C00',
        topbar: '#1E1E1E',
        note: '#43a047',
        drill: '#7e57c2',
        quiz: '#f57c00',
        link: '#72b1df',
        link2: '#aaaaaa',
      },
      dark: {
        background: '#174458',
        primary: '#72b1df',
        secondary: '#424242',
        accent: '#FD8A8D',
        error: '#d50000',
        info: '#FEB5B7',
        success: '#4CAF50',
        warning: '#FB8C00',
        topbar: '#1b242d',
        note: '#43a047',
        drill: '#7e57c2',
        quiz: '#f57c00',
        link: '#ffffff',
        link2: '#aaaaaa',
      },
    },
  },
});
